import { MessageCircle } from "lucide-react";

export default function WhatsAppButton() {
  const phone = "917982650076";
  const text = encodeURIComponent("Hello AR Overseas — I'd like to discuss an export inquiry.");
  return (
    <a
      href={`https://wa.me/${phone}?text=${text}`}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-button"
      className="fixed bottom-6 right-6 z-50 h-14 w-14 rounded-full bg-[#25D366] text-white shadow-lg flex items-center justify-center hover:scale-110 transition-transform"
      aria-label="Chat on WhatsApp"
    >
      <MessageCircle size={24} fill="white" />
      <span className="absolute right-full mr-3 whitespace-nowrap rounded-full glass-dark text-white text-xs uppercase tracking-widest px-4 py-2 opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none hidden md:block">
        WhatsApp
      </span>
    </a>
  );
}
